/* eslint-disable unicorn/better-regex */
/* eslint-disable unicorn/no-unsafe-regex */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/jsx-child-element-spacing */
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded'
import { LoadingButton } from '@mui/lab'
import { darken, Fab, Link, Stack, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { browserName, osName } from 'react-device-detect'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useParams } from 'react-router-dom'

import { createFanItem } from 'src/api/fans'
import { getMarketingLinkById } from 'src/api/links'
import { getBasicOrganisation } from 'src/api/organisation'
import type { trackingData } from 'src/components/pages/SmartLink/ReleasePreview'
import { type MarketingLink, MarketingEvent } from 'src/models/Marketing'
import type { BasicOrganisation } from 'src/models/Organisation'
import * as darkTheme from 'src/styles/dark.theme'
import * as lightTheme from 'src/styles/light.theme'

const linkUrl = 'https://geolocation-db.com/json/c8a566e0-859f-11ec-b0ca-adb932d26d38'

const validateEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

const SignUpFormModern = () => {
  const { linkId } = useParams<{ linkId: string }>()
  const { organisationId } = useParams<{ organisationId: string }>()
  const { eventItem } = useParams<{ eventItem: string }>()
  const { platform } = useParams<{ platform: string }>()
  const platformPrettyString = platform

  const [trackingData, setTrackingData] = useState<trackingData>()
  const [organisation, setOrganisation] = useState<BasicOrganisation | null>(null)
  const [link, setLink] = useState<MarketingLink>()
  const [done, setDone] = useState(false)
  const [loading, setLoading] = useState(false)
  const [mode, setMode] = useState('email')
  // const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')

  /*
  const handlePhoneChange = (_event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string) => {
    if (typeof _event === 'string') {
      setPhone(_event)
    }
  }
  */

  const activeTheme = link?.palette === 'Dark'
    ? darkTheme
    : lightTheme

  const { executeRecaptcha } = useGoogleReCaptcha()

  const submit = async () => {
    setLoading(true)
    if (!executeRecaptcha) {
      setLoading(false)
      console.warn('Recaptcha not yet available')
      return
    }

    const recaptchaToken = await executeRecaptcha('fan_form')
    if (!recaptchaToken) {
      setLoading(false)
      console.warn('Recaptcha token not received')
      return
    }

    if (link?.id && organisation?.id && eventItem) {
      setLoading(true)
      await createFanItem(
        organisation.id,
        link.id,
        new MarketingEvent({
          marketingLinkId: '',
          destination: '',
          presavePlatform: '',
          browser: browserName,
          operatingSystem: osName,
          country: trackingData?.country_name ?? 'Unknown',
          city: trackingData?.city ?? 'Unknown',
        }),
        eventItem.replaceAll('-', ' '),
        recaptchaToken,
        platformPrettyString,
        mode === 'email'
          ? email
          : undefined,

        /*
        mode === 'phone'
          ? phone
          : undefined,
          */
        undefined,
      )
        .finally(() => {
          setDone(true)
          setLoading(false)
        })
        .catch(() => {
          setDone(true)
          setLoading(false)
        })
    }
  }

  const setupInital = async () => {
    if (linkId && organisationId) {
      await Promise.all([
        getMarketingLinkById(linkId)
          .then(linkItem => {
            setLink(linkItem)
          }),
        getBasicOrganisation(organisationId)
          .then(orgItem => {
            setOrganisation(orgItem)
          }),
        fetch(linkUrl, { method: 'get' })
          .then(response => response.json())
          .then((data: trackingData | undefined) => {
            setTrackingData(data)
          }),
      ]).catch(() => null)
    }
  }

  useEffect(() => {
    void setupInital()
  }, [organisationId, linkId])

  return (
    <Stack spacing={1} width={1}>
      {done
        ? <Stack alignItems='center' direction='column' paddingTop={2} spacing={2} width={1}>
          <CheckCircleRoundedIcon
            sx={{
              color: activeTheme.default.palette.success.main,
              fontSize: '32px',
            }}
          />
          <Typography
            sx={{
              color: activeTheme.default.palette.text.primary,
            }}
            variant='body1'
          >
            You have signed up to
            {` ${organisation?.name}`}
          </Typography>
        </Stack>
        : <>
          <Stack alignItems='center' direction='row' justifyContent='space-between' spacing={2} width={1}>
            <Typography
              color={activeTheme.default.palette.text.primary}
              lineHeight={1.2}
              sx={{
                color: activeTheme.default.palette.text.primary,
              }}
              textAlign='center'
              variant='h3'
            >
              Sign up
            </Typography>
            <Stack direction='row' spacing={1}>
              {/*
              <Fab
                onClick={() => setMode('phone')}
                sx={{
                  background: mode === 'phone'
                    ? link?.palette === 'Light'
                      ? activeTheme.default.palette.action.active
                      : '#3d3d3d'
                    : 'transparent',
                  boxShadow: 'none',
                }}
              >
                <ChatBubbleRoundedIcon />
              </Fab>
              */}
              <Fab
                onClick={() => setMode('email')}
                sx={{
                  background: mode === 'email'
                    ? link?.palette === 'Light'
                      ? activeTheme.default.palette.action.active
                      : '#3d3d3d'
                    : 'transparent',
                  boxShadow: 'none',
                }}
              >
                <EmailRoundedIcon />
              </Fab>
            </Stack>
          </Stack>
          {/*
          {mode === 'phone' &&
          <>
            <Stack width={1}>
              <MuiPhoneNumber
                defaultCountry='us'
                fullWidth
                onChange={handlePhoneChange}
                sx={{
                  marginTop: 0,
                  '.MuiInputBase-root': {
                    borderRadius: 64,
                    background: link?.palette === 'Light'
                      ? `${darken('#F3F4F6', 0.04)}!important`
                      : '#4E4F50!important',
                    border: '0px solid transparent',
                  },
                  '.MuiFilledInput-input': {
                    color: `${activeTheme.default.palette.text.primary}!important`,
                  },
                }}
                value={phone}
                variant='filled'
              />
            </Stack>
            <LoadingButton
              loading={loading}
              onClick={() => void submit()}
              rounded
              variant='contained'
            >
              Sign up to
              {` ${organisation?.name}`}
            </LoadingButton>
            <Stack height='64px' width={1}>
              <Typography color={activeTheme.default.palette.text.label} variant='body3'>
                By submitting my information, I agree to receive recurring automated messages to the contact
                information provided from
                {` ${organisation?.name}, `}
                {'to Releese\'s '}
                <Link href='https://releese.io/legal/terms-and-conditions/' target='_blank'>
                  Terms and Conditions
                </Link>
                {', '}
                <Link href='https://releese.io/legal/privacy-policy/' target='_blank'>
                  Privacy Policy
                </Link>
                {', and '}
                <Link href='https://releese.io/legal/cookie-policy/' target='_blank'>
                  Cookie Policy
                </Link>
                {` SMS & Data Rates may apply. Reply STOP to unsubscribe at any time. Consent is not a
                condition of purchase. This site is protected by reCAPTCHA and the Google `}
                <Link href='https://policies.google.com/privacy' target='_blank'>Privacy Policy</Link>
                {', and '}
                <Link href='https://policies.google.com/terms' target='_blank'>Terms of Service</Link>
                {' apply.'}
              </Typography>
            </Stack>
          </>}
           */}
          {mode === 'email' &&
          <>
            <Stack width={1}>
              <TextField
                onChange={event => setEmail(event.target.value)}
                placeholder='me@me.com'
                sx={{
                  marginTop: 0,
                  '.MuiInputBase-root': {
                    borderRadius: 64,
                    background: link?.palette === 'Light'
                      ? `${darken('#F3F4F6', 0.04)}!important`
                      : '#4E4F50!important',
                    border: '0px solid transparent',
                  },
                  '.MuiFilledInput-input': {
                    color: `${activeTheme.default.palette.text.primary}!important`,
                  },
                }}
                value={email}
              />
            </Stack>
            <LoadingButton
              disabled={!validateEmail.test(email)}
              loading={loading}
              onClick={() => void submit()}
              rounded
              variant='contained'
            >
              Sign up to
              {` ${organisation?.name}`}
            </LoadingButton>
            <Stack height='64px' width={1}>
              <Typography color={activeTheme.default.palette.text.label} variant='body3'>
                By submitting my information, I agree to receive emails to the contact
                information provided from
                {` ${organisation?.name}, `}
                {' and to Releese\'s '}
                <Link href='https://releese.io/legal/terms-and-conditions/' target='_blank'>
                  Terms of Service
                </Link>
                {', '}
                <Link href='https://releese.io/legal/cookie-policy/' target='_blank'>Cookie Policy</Link>
                {', and '}
                <Link href='https://releese.io/legal/privacy-policy/' target='_blank'>Privacy Policy</Link>
                {'. '}
                {' This site is protected by reCAPTCHA and the Google '}
                <Link href='https://policies.google.com/privacy' target='_blank'>Privacy Policy</Link>
                {', and '}
                <Link href='https://policies.google.com/terms' target='_blank'>Terms of Service</Link>
                {' apply.'}
              </Typography>
            </Stack>
          </>}
        </>}
    </Stack>
  )
}

export default SignUpFormModern
